import React, { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { LicensedSection } from './components/LicensedSection';
import { ServicesSection } from './components/ServicesSection';
import { WorkGallery } from './components/WorkGallery';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { ReviewsSection } from './components/ReviewsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { ScheduleFormSection } from './components/ScheduleFormSection';
import { ScheduleModal } from './components/ScheduleModal';
import { FloatingCallButton } from './components/FloatingCallButton';
import { Footer } from './components/Footer';
export function App() {
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  return <div className="flex min-h-full w-full flex-col bg-white" data-id="element-0" data-mp="3ihv22ef0kliv">
      <Header onOpenSchedule={() => setIsScheduleOpen(true)} data-id="element-1" data-mp="3mkho1yp07c85" />
      <main className="flex-1" data-id="element-2" data-mp="3rcj6618urx63">
        <Hero onOpenSchedule={() => setIsScheduleOpen(true)} data-id="element-3" data-mp="3rdas0kcnegj6" />
        <ServicesSection onOpenSchedule={() => setIsScheduleOpen(true)} data-id="element-4" data-mp="5yh2n2cyzbp" />
        <ProblemSection data-id="element-5" data-mp="82kl3wchwbg" />
        <LicensedSection data-id="element-6" data-mp="2zld1d7i6tbah" />
        <WorkGallery data-id="element-7" data-mp="2zlv3gkrj6jqb" />
        <ServiceAreaSection data-id="element-8" data-mp="2zmo3z3zwcd00" />
        <ReviewsSection data-id="element-9" data-mp="2zng0ch1bierc" />
        <GuaranteeSection data-id="element-10" data-mp="33m5be2yvvk7t" />
        <OfferSection data-id="element-11" data-mp="33nq921ghvj9w" />
        <FaqSection data-id="element-12" data-mp="33mykhalbelt4" />
        <ScheduleFormSection data-id="element-13" data-mp="33oi152avuyvf" />
        <FinalCta onOpenSchedule={() => setIsScheduleOpen(true)} data-id="element-14" data-mp="38l8f9k34nke7" />
      </main>
      <Footer data-id="element-15" data-mp="3dkurprb4swly" />
      <FloatingCallButton data-id="element-16" data-mp="3dle46si0issl" />
      <ScheduleModal open={isScheduleOpen} onClose={() => setIsScheduleOpen(false)} data-id="element-17" data-mp="3dlns8ajhypvn" />
    </div>;
}